var map = {
	"./en/teacher/common.js": 21387,
	"./vi/common/audit-log.js": 30321,
	"./vi/common/button.js": 53625,
	"./vi/common/common.js": 19580,
	"./vi/common/controls.js": 36095,
	"./vi/common/date.js": 65309,
	"./vi/common/enum.js": 97428,
	"./vi/common/error-message.js": 31009,
	"./vi/common/google-drive.js": 25159,
	"./vi/common/navigation.js": 15555,
	"./vi/common/newsfeed.js": 9498,
	"./vi/common/notify-message.js": 26642,
	"./vi/common/notify.js": 46968,
	"./vi/common/support.js": 4646,
	"./vi/common/tour-guide.js": 7758,
	"./vi/common/user.js": 37170,
	"./vi/common/validate.js": 79983,
	"./vi/teacher/asessment-period.js": 50861,
	"./vi/teacher/assignment.js": 21673,
	"./vi/teacher/calendar.js": 47046,
	"./vi/teacher/class-room.js": 65404,
	"./vi/teacher/correcting-exercise.js": 85357,
	"./vi/teacher/dashboard.js": 93418,
	"./vi/teacher/document.js": 81581,
	"./vi/teacher/event-calendar.js": 49689,
	"./vi/teacher/exam-period.js": 61661,
	"./vi/teacher/exam-store.js": 85355,
	"./vi/teacher/exercise.js": 88418,
	"./vi/teacher/export.js": 69214,
	"./vi/teacher/feature.js": 59632,
	"./vi/teacher/galactic-warrior-game.js": 50670,
	"./vi/teacher/news-feed.js": 51012,
	"./vi/teacher/rating-teacher.js": 37797,
	"./vi/teacher/student.js": 80497,
	"./vi/teacher/survey.js": 2630,
	"./vi/teacher/teacher.js": 10168,
	"./vi/teacher/training.js": 33506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2956;